import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import chicken from '../meats/svg/001-chicken.svg'
import meat from '../meats/svg/002-meat.svg'
import fish from '../meats/svg/003-fish.svg'
import turkey from '../meats/svg/006-turkey.svg'
import pig from '../meats/svg/004-pig.svg'
import mariscos from '../meats/svg/seafood.svg'
import cordero from '../meats/svg/sheep.svg'
import nomeat from '../meats/svg/005-meat-1.svg'
import soymilk from '../allergies/svg/001-soy-milk.svg'
import milk from '../allergies/svg/002-milk-products.svg'
import eggs from '../allergies/svg/003-eggs.svg'
import walnut from '../allergies/svg/004-walnut.svg'
import gluten from '../allergies/svg/005-gluten.svg'
import noallergies from '../allergies/svg/no-stopping.svg'
import nosleep from '../badhabits/svg/001-slumber.svg'
import comertarde from '../badhabits/svg/002-cutlery.svg'
import muchasal from '../badhabits/svg/003-salt.svg'
import muchodulce from '../badhabits/svg/004-toffee.svg'
import tomargaseosas from '../badhabits/svg/005-can.svg'
import { connect } from 'react-redux'
import grafico from '../../assets/img/001-grafico-de-ondas.png'
import ensalada from '../../assets/img/002-ensalada.png'
import lista from '../../assets/img/003-lista.png'
import medico from '../../assets/img/004-medico.png'
import cena from '../../assets/img/005-cena.png'
import ideas from '../../assets/img/006-ideas.png'

import legumes from '../allergies/svg/legumbres.svg'
import axios from 'axios'
import dietStyle from '../dietStyle/dietStyle'
import { useEffect } from 'react'
import Swal from 'sweetalert2'
import moment from 'moment'
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown'
import '@leenguyen/react-flip-clock-countdown/dist/index.css'
import ButtonPlanComponent from './button'
const svgCarnes = [chicken, meat, fish, turkey, pig, mariscos, cordero, nomeat] // Removed undefined variables
const meatTitle = [
  'Pollo',
  'Ternera',
  'Pezcado',
  'Pavo',
  'Cerdo',
  'Mariscos',
  'Cordero',
  'Ninguna',
]
const svgAllergies = [soymilk, milk, eggs, walnut, gluten, legumes, noallergies] // Removed undefined variables
const allergiesTitle = [
  'Soya',
  'Lácteos',
  'Huevos',
  'Nueces',
  'gluten',
  'Legumbres',
  'Ninguna',
]

const svgBadHabits = [
  nosleep,
  comertarde,
  muchasal,
  muchodulce,
  tomargaseosas,
  noallergies,
] // Removed undefined variables
const badhabitsTitle = [
  'No dormir lo suficiente',
  'comer muy tarde',
  'Mucha sal en las comidas',
  'Mucho dulce y bollería',
  'Tomar gaseosas',
  'Ninguno',
] // Removed undefined variables

class Timeline extends Component {
  render() {
    return <></>
  }
}

let isLangchainRequestInProgress = false

class Nutrition extends Component {
  constructor(props) {
    super(props)

    this.targetTime = Date.now() + 3600 * 1000
    this.state = {
      paymentDate: localStorage.getItem('paymentDate')
        ? moment(localStorage.getItem('paymentDate'))
        : null,
      cta: React.createRef(),
      visible: false,
    }
    this.sentData = false
    this.sendTimeout = null
  }

  toDown() {
    this.state.cta.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    })
  }
  handleScroll = () => {
    const currentScrollPos = window.scrollY
    if (this.state.cta.current) {
      const { offsetTop } = this.state.cta.current
      const visible = currentScrollPos > 100 && currentScrollPos < offsetTop
      console.log(visible, currentScrollPos, offsetTop)
      this.setState({
        visible,
      })
    }
  }

  newCalc() {
    localStorage.removeItem('dataCalc')
    localStorage.removeItem('venc')
    localStorage.removeItem('dateCalc')
    window.location.reload()
  }
  actividadFisicaCase(value) {
    switch (value) {
      case 'S':
        return 'Sedentario (Trabajo de oficina)'
      case 'EL':
        return 'ejercicio leve (1 a 2 días por semana)'
      case 'EM':
        return 'ejercicio moderado (3 a 5 días por semana)'
      case 'ED':
        return 'ejercicio duro (6 a 7 días por semana)'
      case 'A':
        return 'Atleta (2 veces al día)'
      default:
        return 'No definido'
    }
  }
  setObjetive(obj) {
    switch (obj) {
      case 1:
        return 'Aumentar masa muscular'
      case 2:
        return 'Mantenimiento'
      case 3:
        return 'Perder grasa corporal'
      default:
        return ''
    }
  }

  setBmiTipo(bmi) {
    if (bmi < 18.5) {
      return 'Bajo peso'
    }
    if (bmi >= 18.5 && bmi <= 24.9) {
      return 'Peso normal'
    }
    if (bmi >= 25 && bmi <= 29.9) {
      return 'Sobrepeso'
    }
    if (bmi >= 30) {
      return 'Obesidad'
    }
  }
  getAlimentationTypeDesc(type) {
    const options = [
      {
        value: 'omnivora',
        title: 'Omnívora 🥦🥩',
        desc: 'Comes de todo: carne, pescado, huevos, lácteos, frutas, verduras, cereales, legumbres.',
      },
      {
        value: 'pescetariana',
        title: 'Pescetariana 🐟🥦',
        desc: 'No comes carne, pero sí pescado, mariscos, huevos, lácteos, frutas, verduras, cereales y legumbres.',
      },
      {
        value: 'vegetariana',
        title: 'Vegetariana 🥦',
        desc: 'No comes carne ni pescado, pero sí huevos y/o lácteos.',
      },
      {
        value: 'vegana',
        title: 'Vegana 🌱',
        desc: 'Solo alimentos de origen vegetal (sin carne, pescado, huevos, lácteos ni miel).',
      },
    ]
    const element = options.find((option) => option.value === type.type)
    return element
  }
  setAlimentationType(type) {
    const element = this.getAlimentationTypeDesc(type)
    return (
      <>
        <b>{element?.title}</b>
        <br />
        <span style={{ fontSize: '12px' }}>{element?.desc}</span>
        <br />
        {type?.type === 'vegetariana' ? (
          <>
            <p
              style={{
                marginTop: '10px',
                marginBottom: '0px',
                fontSize: '12px',
              }}
            >
              Puedes consumir:
            </p>
            <span style={{ fontSize: '12px' }}>
              {type?.lacteos && 'Lácteos'} {type.huevos && 'Huevos'}
            </span>
          </>
        ) : null}
      </>
    )
  }
  setDietStyle(style) {
    const options = [
      {
        value: 1,
        title: 'Muy baja en carbohidratos (Keto / Cetogénica)',
      },
      {
        value: 2,
        title: 'Baja en carbohidratos (Low Carb)',
      },
      {
        value: 3,
        title: 'Moderada en carbohidratos (Balanceada)',
      },
    ]
    const element = options.find((option) => option.value === style)
    return element ? element.title : ''
  }
  async sendData(send_now = false) {
    if (this.sentData || isLangchainRequestInProgress || !this.props.email || !this.props.name) return
    this.sentData = true
    isLangchainRequestInProgress = true

    const data = {
      edad: this.props.edad,
      peso: `${this.props.peso} ${
        this.props.type_measure === 0 ? 'kg' : 'lbs'
      }`,
      altura: `${this.props.altura} ${
        this.props.type_measure === 0 ? 'cm' : 'in'
      }`,
      name: this.props.name,
      email: this.props.email,
      sexo: this.props.sexo,
      actividad_fisica: this.actividadFisicaCase(this.props.actividad_fisica),
      carnes: this.props.carnes
        .map((item, index) => (item === true ? meatTitle[index] : false))
        .filter((item) => item !== false),
      alergias: this.props.alergias
        .map((item, index) => (item === true ? allergiesTitle[index] : false))
        .filter((item) => item !== false),
      maloshabitos: this.props.maloshabitos
        .map((item, index) => (item === true ? badhabitsTitle[index] : false))
        .filter((item) => item !== false),
      objetivo: this.setObjetive(this.props.objetivo),
      calorias_nivel: this.props.calorias_nivel,
      calorias_objetivo:
        this.props.objetivo === 1
          ? this.props.calorias_objetivo + this.props.calorias_editor
          : this.props.calorias_objetivo - this.props.calorias_editor,
      bmi: this.props.bmi,
      bmi_interpretation: this.setBmiTipo(this.props.bmi),
      peso_ideal_kg: this.props.peso_ideal_kg,
      mpm_superior: this.props.mpm_superior,
      mpm_inferior: this.props.mpm_inferior,
      proteinasgramos: this.props.proteinas_dia_g,
      grasasgramos: this.props.grasa_dia_g,
      carbohidratosgramos: this.props.carbohidratos_dia_g,
      dietStyle: this.setDietStyle(this.props.dietStyle),
      cantidadComidas: this.props.cantidadComidas,
      tipoalimentacion:
        this.getAlimentationTypeDesc(this.props.tipoalimentacion)?.value || '',
      vegetarianOptions: {
        huevos: this.props.tipoalimentacion?.huevos || false,
        lacteos: this.props.tipoalimentacion?.lacteos || false,
      },
    }
    // Remove double slash if REACT_APP_API_URL ends with one
    const baseUrl = process.env.REACT_APP_API_URL.endsWith('/')
      ? process.env.REACT_APP_API_URL.slice(0, -1)
      : process.env.REACT_APP_API_URL

    const url = `${baseUrl}/api/langchain?send_now=${send_now}`

    try {
      const response = await axios({
        url: url,
        method: 'POST',
        data,
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (response.status === 202) {
        this.props.changePage(11)
      }
    } catch (error) {
      this.sentData = false
      isLangchainRequestInProgress = false
      console.error('Error sending data to langchain:', error)
      Swal.fire({
        title: 'Error',
        text: 'Hubo un problema al procesar tu solicitud. Por favor intenta de nuevo.',
        icon: 'error',
      })
    }

  }

  async changeTag() {
    if (this.props.contactId) {
      const url = `https://services.leadconnectorhq.com/contacts/${this.props.contactId}/tags`
      var body = JSON.stringify({
        tags: ['Calculadora de Calorías', 'Plan adquirido'],
      })
      const response = await axios({
        url: url,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${process.env.REACT_APP_HIGLEVEL_TOKEN}`,
          version: '2021-07-28',
        },
        data: body,
      })
    }
  }
  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
    this.checkAutoSend()
  }


  componentDidUpdate(prevProps) {
    // Si los datos acaban de llegar (el email pasó de vacío a tener valor), intentar auto-envío
    if (!prevProps.email && this.props.email) {
      this.checkAutoSend()
    }
  }

  checkAutoSend() {
    const queryString = window.location.search
    const params = new URLSearchParams(queryString)
    const value = params.get('payment')
    const adminParam = params.get('admin')
    const storedDate = localStorage.getItem('paymentDate')

    const payment = storedDate ? moment(storedDate) : null
    this.setState({
      paymentDate: storedDate ? moment(storedDate) : null,
    })
    const is24h =
      payment && payment.isValid()
        ? moment().diff(payment, 'hours') >= 48
        : false

    if (adminParam === 'admin*2026' && !isLangchainRequestInProgress) {
      this.sendTimeout = setTimeout(() => {
        this.sendData(true)
      },1000)
    } else if (
      !is24h &&
      value &&
      value === 'true' &&
      this.props.email !== '' &&
      !isLangchainRequestInProgress
    ) {
      this.sendTimeout = setTimeout(() => {
        this.changeTag()
        this.sendData()
        localStorage.setItem('paymentDate', new Date().toISOString())
      }, 500)
    }
  }



  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.sendTimeout) {
      clearTimeout(this.sendTimeout)
    }
  }


  render() {
    return (
      <div>
        <button
          className={`navigate-button ${this.state.visible ? 'show' : null}`}
          onClick={() => this.toDown()}
        >
          Click aquí para tener tu plan personalizado
        </button>
        <div className="cta" ref={this.state.cta} id="nutricion">
          <div className="container section-primary">
            <div>
              <h1 className="title">
                Tu cuerpo no necesita una dieta genérica.
              </h1>
              <h1 className="title">
                <span>
                  Necesita un plan diseñado como si tuvieras un nutricionista
                  solo para ti.
                </span>
              </h1>
              <p className="subtitle">
                Diseñamos tu alimentación según tu cuerpo real, tus hábitos y tu
                estilo de vida. No usamos plantillas. No adivinamos que
                necesitas. No repetimos dietas.
              </p>
              <p className="subtitle">
                Creamos tu dieta como si tu metabolismo fuera un proyecto único.
              </p>
              <ul>
                <li>Sin pasar hambre</li>
                <li>Sin contar calorías de por vida</li>
                <li>Sin eliminar alimentos innecesariamente</li>
                <li>Sin vivir a dieta</li>
              </ul>
              <p>Esto no es una dieta</p>
              <p
                style={{
                  fontSize: '16px',
                  fontWeight: 'normal',
                  margin: '0px',
                }}
              >
                Es un sistema de alimentación bioindividual que adapta comida,
                calorías y estructura de comidas a tu realidad, no a una
                tendencia
              </p>
              <div id="first-cta-btn">
 <p className="price-now">
  <p className="price-before">
              Antes <span>$197</span>
            </p>
              Hoy <strong>$97</strong> pago único
            </p>
              <ButtonPlanComponent></ButtonPlanComponent>
               <p  style={{
                  fontSize: '16px',
                  fontWeight: 'normal',
                  margin: '0px',
                }}>Obten todo el plan con un solo pago, sin mensualidades ni cuotas ocultas</p>
         
              </div>
              
            </div>
          </div>
        </div>
        {/* <div className="cta-second">
          <div className="container">
            <div className="section-icons">
              <div className="content">
                <div>
                  <img src={ensalada} alt="ensalada" />
                  <h6>Dieta 100% personalizada</h6>
                  <p>
                    Basada en tus objetivos, nivel de actividad y tipo de
                    alimentación (omnivora, vegetariana, etc)
                  </p>
                </div>
                <div>
                  <img src={grafico} alt="ensalada" />
                  <h6>Análisis de Calorias y Macros</h6>
                  <p>
                    Calculado cientificamente segun tu composición corporal y
                    ritmo metabolico
                  </p>
                </div>
                <div>
                  <img src={ideas} alt="ensalada" />
                  <h6>Guía Educativa</h6>
                  <p>
                    Aprende a entender tu cuerpo y tomar decisiones inteligentes
                    con la comida
                  </p>
                </div>
                <div>
                  <img src={cena} alt="ensalada" />
                  <h6>Organización por Comidas y Horarios</h6>
                  <p>Diseñada para adaptarse a tu vida real</p>
                </div>
                <div>
                  <img src={lista} alt="ensalada" />
                  <h6>Lista de Compras automatica</h6>
                  <p>
                    Con todos los alimentos de tu plan, practica, clara y
                    editable
                  </p>
                </div>
                <div>
                  <img src={medico} alt="ensalada" />
                  <h6>Soporte de Expertos</h6>
                  <p>
                    Acceso directo a nuestro equipo para resolver tus dudas y
                    ajustar tu plan
                  </p>
                </div>
              </div>
            </div>
            <div className="section-reco">
              <h5>
                No necesitas más fuerza de voluntad. Solo necesitas un plan
                hecho para ti.
              </h5>
            </div>
            <div className="section-info">
              <h3>
                Tu cuerpo cambia cuando dejas de adivinar y comienzas a seguir
                un plan hecho para ti
              </h3>
              <p>
                Recibe una dieta 100% personalizada según tus objetivos, gustos
                y horarios, diseñada por expertos en nutrición funcional.
              </p>
              {moment().diff(moment(this.state.paymentDate), 'hours') >= 24 ? (
                <a
                  onClick={() => localStorage.removeItem('paymentDate')}
                  href={`${process.env.REACT_APP_STRIPE_URL}?locked_prefilled_email=${this.props.email}&name=${this.props.name}`}
                  className="nutrition-button"
                >
                  <i className="fas fa-hand-point-right"></i>QUIERO MI PLAN
                  PERSONALIZADO
                </a>
              ) : (
                <button
                  onClick={() => this.sendData()}
                  className="nutrition-button"
                >
                  <i className="fas fa-hand-point-right"></i>QUIERO MI PLAN
                  PERSONALIZADO
                </button>
              )}
            </div>
          </div>
        </div> */}
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  page: state.page,
  sexo: state.sexo,
  actividad_fisica: state.actividad_fisica,
  carnes: state.carnes,
  alergias: state.alergias,
  maloshabitos: state.maloshabitos,
  objetivo: state.objetivo,
  edad: state.edad,
  altura: state.altura,
  peso: state.peso,
  email: state.email,
  name: state.name,
  type_measure: state.type_measure,
  bmr: state.bmr,
  calorias_nivel: state.calorias_nivel,
  bmi: state.bmi,
  peso_ideal_kg: state.peso_ideal_kg,
  mpm_superior: state.mpm_superior,
  mpm_inferior: state.mpm_inferior,
  calorias_objetivo: state.calorias_objetivo,
  calorias_editor: state.calorias_editor,
  proteinas_dia_g: state.proteinas_dia_g,
  grasa_dia_g: state.grasa_dia_g,
  carbohidratos_dia_g: state.carbohidratos_dia_g,
  tipoalimentacion: state.tipoalimentacion,
  dietStyle: state.dietStyle,
  cantidadComidas: state.cantidadComidas,
  contactId: state.contactId,
})
const mapDispatchToProps = (dispatch) => ({
  changePage(page) {
    dispatch({
      type: 'CHANGE_PAGE',
      page: page,
    })
  },
})
export default connect(mapStateToProps, mapDispatchToProps)(Nutrition)
